export const version = "web/5.6.0";
//# sourceMappingURL=_version.js.map